<template>
  <div class="not-found">
    <h1>Not Found</h1>
  </div>
</template>

<script>
export default {};
</script>
